<template>
  <div class="border-work-wrapper">
    <h3 data-aos="fade-left">{{ $t('ac_cleaning.question_section.title') }}</h3>
    <div
      v-for="(q, index) in questions"
      :key="index"
      class="question-item"
    >
      <div
        class="question-header"
        @click="setQuesionIndex(index)"
        :class="{ active: questionIndex === index }"
      >
        <!-- <p class="list">{{ q.question }}</p> -->
      <p class="list">
        {{ $t(`ac_cleaning.question_section.questions.${index}.question`) }}
      </p>
        <img
          :src="questionIndex === index ? minusIcon : plusIcon"
          alt="toggle"
        />
      </div>

      <ul v-if="q.contents.length > 0 && questionIndex === index" class="list-unstyled question-content">
        <!-- <li v-for="(content, cIndex) in q.contents" :key="cIndex" v-html="content"></li> -->
        <li v-for="(content, cIndex) in q.contents" :key="cIndex" 
        v-html="$t(`ac_cleaning.question_section.questions.${index}.answer.${cIndex}`)"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      questionIndex: null,
      plusIcon: '/static/img/acCleaning/svg/Plus.svg',
      minusIcon: '/static/img/acCleaning/svg/Minus.svg',
      title: 'คำถามที่พบบ่อยเกี่ยวกับบริการล้างแอร์ของ BeNeat',
      questions: [
        {
          question: 'ควรล้างแอร์กี่เดือนครั้ง?',
          contents: [
            'เพื่อให้เครื่องปรับอากาศของคุณทำงานได้เต็มประสิทธิภาพ และปลอดภัยต่อสุขภาพ BeNeat แนะนำให้ ล้างแอร์ทุก 4–6 เดือน',
            '✅ หากใช้งานเป็นประจำ อยู่ในพื้นที่ที่มีฝุ่นมาก หรือมีสัตว์เลี้ยง 👉 ควรล้างแอร์ทุก 3–4 เดือน']
        },
        {
          question: 'บริการล้างแอร์ของ BeNeat มีประกันไหม?',
          contents: [
            'บริการล้างแอร์ของ BeNeat รับประกันงาน 14 วัน หากพบปัญหาหลังการล้าง เช่น แอร์ไม่เย็น น้ำหยด หรือเสียงผิดปกติ ทีมช่างสามารถกลับเข้าไปตรวจสอบและแก้ไขได้โดยไม่มีค่าใช้จ่ายเพิ่มเติม',
            '🔒 พร้อมความคุ้มครองกรณีความเสียหายระหว่างให้บริการ วงเงินสูงสุด ไม่เกิน 10,000 บาท'
          ]
        },
        {
          question: 'การจองแบบไม่ระบุวันเวลา เปลี่ยนเองในแอปได้หรือไม่?',
          contents: [
            'ได้ค่ะ คุณสามารถแก้ไขวันและเวลาให้บริการภายหลังได้ผ่านแอป BeNeatเพียงเข้าสู่ระบบ',
            '→ เลือก “รายการจองของฉัน”'
          ]
        },
        {
          question: 'ช่างแอร์เข้าทำงานกี่คน',
          contents: [
            'บริการล้างแอร์ BeNeat ทีมผู้ให้บริการจะเข้าให้บริการเป็นทีม และจะมีหัวหน้างาน 1 ท่าน คอยกำกับการปฏิบัติงานตลอดเวลา 1 การจองต่อ 1 สถานที่พักของคุณลูกค้า'
          ]
        },
        {
          question: 'เราจะมั่นใจทีมช่างของ Beneat ได้อย่างไร',
          contents: [
            'BeNeat คัดเลือกผู้ให้บริการอย่างเข้มงวด เพื่อความมั่นใจสูงสุดของลูกค้า',
            '✅ ช่างทุกคนผ่านการอบรมมาตรฐาน และตรวจสอบประวัติอาชญากรรมแล้ว',
            '✅ มาพร้อมอุปกรณ์และน้ำยาทำความสะอาดคุณภาพ',
            '✅ มีทีมแอดมินพร้อมดูแล ให้คำแนะนำ และประสานงานตลอดบริการ',
            '✅ หลังล้างเสร็จ ทีมจะทำความสะอาดพื้นที่ให้เรียบร้อย'
          ]
        }
      ]
    }
  },
  methods: {
    setQuesionIndex (index) {
      this.questionIndex = this.questionIndex === index ? null : index
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/sass/page/ac_cleaning.scss';

.border-work-wrapper {
  margin-top: 5%;
}

h3 {
  font-size: 28px;
  font-weight: 600;
  color: black;
  margin-bottom: 24px;
}

.question-item {
  margin-bottom: 16px;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border: 1px solid #E8EAEE;
  border-radius: 6px;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.3s;

  &.active {
    background: #f4f8f7;
  }

  .list {
    font-size: 16px;
    color: #28313C;
    margin: 0;
    font-weight: 500;
  }

  img {
    width: 20px;
    height: 20px;
    transition: transform 0.3s;
  }
}

.question-content {
  background: #fafafa;
  border-left: 2px solid $secon-color;
  padding: 12px 24px;
  margin-top: 8px;
  font-size: 15px;
  color: #444;

  li {
    margin-bottom: 6px;
  }
}

@media (min-width: 1024px) {
  h3 {
    font-size: 48px;
  }

  .question-header {
    padding: 20px 24px;
  }

  .question-content {
    padding: 16px 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/acCleaningRe/Questions.vue